import { useState, useRef, useEffect } from "react";
import "./style.css";

const services = [
  "Registration",
  "Company Registration",
  "Private Limited Company",
  "Limited Liability Partnership (LLP)",
  "One Person Company",
  "Section 8 Company (Non Profit Organization)",
  "Public Limited Company",
  "Gst Registration",
  "Professional Tax Registration (P-Tax)",
  "Pan & Tan Registration",
  "Udyam / MSME Registration",
  "Startup India Registration",
  "Import Export Code",
  "Tax & Compliances",
  "Direct Tax",
  "Income Tax Filing",
  "Individual",
  "LLP",
  "Company",
  "AOP",
  "BOI",
  "TDS & TCS Filing",
  "Tax Audit (Form 3CA / 3CB / 3CD)",
  "Statutory Audit",
  "Pan Correction and Reissue",
  "Assessment & Representation",
  "Advance Tax and Self Assessment Tax",
  "Capital Gains & Investment Advisory",
  "Indirect Tax",
  "Gst Registrations & Services",
  "GST Return Filing (GSTR 1, 3B, 4, 9/9C)",
  "GST Audit & Certification",
  "GST Refund & Export Related Services",
  "GST Advisory & Planning Tax",
  "Input Tax Credit Management",
  "Representation & Litigation Support",
  "E-invoicing & E-way bill Compliance",
  "Trademark & Certifications",
  "Trademark Applications & Filing",
  "TradeMark Search And Advisory",
  "Trademark Renewal",
  "Income / Net worth Certificates",
  "Turn over or Profit Certificates",
  "Statutory Certificates",
  "Provisional/Projected Financial Certificate (Project Report)",
  "Working Capital Certificate",
  "Stock / BookDebt Certificate",
  "Fund Flow Certificate",
  "MCA Services",
  "Company Incorporation and Registration",
  "Private Limited Company Registration",
  "One Person Company Registration (OPC)",
  "Limited Liability Partnership Registration",
  "Section 8 Company (Non Profit Organization)",
  "Public Limited Company",
  "Post Incorporation Compliances (INC-20A, ADT-1, etc)",
  "Conversion of Entity Type (LLP to Pvt ltd, etc)",
  "Annual ROC Filings & Compliances",
  "AOC-4 / AOC-4 XBRL - Filing of Financial Statements",
  "MGT-7 / MGT-7A - Annual Return Filing",
  "ADT-1 - Appointment of Auditor",
  "DIR-3 KYC / DIR-3 KYC Web - Directory KYC",
  "DPT-3 - Return of Deposits / Loans / Advances",
  "MGT-14 - Disclosure of Resolutions",
  "Director & ShareHolder Services",
  "DIN Application / Modification",
  "Director Resignation or Appointment Filings",
  "Change in Designation (DIR-12)",
  "DIR-3 KYC filing & Activation",
  "Share Allotment, transfer, and issuance filings",
  "Maintenance of Statutory registers",
  "Secretarial & Legal Documentation",
  "Drafting of MOA / AOA Amendments",
  "Drafting of Board Resolutions",
  "Drafting of Shareholder Meeting Notices & Minutes",
  "Drafting of Directors Reports",
  "Drafting of Share Certificates and Registers",
  "Drafting of Share Transfer Forms (SH-4)",
  "Online CA Services",
  "Accounting Services"
];

export const SearchBox = ({ onServiceSelect }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredServices, setFilteredServices] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const searchRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.trim() === "") {
      setFilteredServices([]);
      setShowDropdown(false);
    } else {
      const filtered = services.filter((service) =>
        service.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredServices(filtered);
      setShowDropdown(true);
    }
  };

  const handleSelectService = (service) => {
    setSearchQuery(service);
    setShowDropdown(false);
    console.log("Selected service:", service);
    // Call the parent callback to open the modal
    if (onServiceSelect) {
      onServiceSelect(service);
    }
  };

  return (
    <div className="search-box-container" ref={searchRef}>
      <div className="search-bar">
        <input
          type="text"
          placeholder="How can we help you (GST, TDS, ITR, Trademark)?"
          className="hero-search-input"
          value={searchQuery}
          onChange={handleSearch}
          onFocus={() => searchQuery && setShowDropdown(true)}
        />
        <button className="search-button">🔍</button>
      </div>

      {showDropdown && filteredServices.length > 0 && (
        <div className="search-dropdown">
          <div className="search-results-header">
            {filteredServices.length} service{filteredServices.length !== 1 ? "s" : ""} found
          </div>
          <div className="search-results">
            {filteredServices.map((service, index) => (
              <div
                key={index}
                className="search-result-item"
                onClick={() => handleSelectService(service)}
              >
                <span className="result-icon">📋</span>
                <span className="result-text">{service}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {showDropdown && searchQuery && filteredServices.length === 0 && (
        <div className="search-dropdown">
          <div className="no-results">
            No services found for "{searchQuery}"
          </div>
        </div>
      )}
    </div>
  );
};

